import React from 'react'
import Axios from 'axios'
import Slider from 'react-slick'
import CircularDeterminate from '../_Components/CircularDeterminate'
import CambistaTemplate from './CambistaTemplate'
import moment from 'moment';
import { Link } from 'react-router-dom';

export class LojaCambista extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
            carrinho: [],
            clienteSelecionado: '',
            buy: false,
            clientes: [],
            screenWidth: window.screen.width,
            statusVenda: false,
            clicked: false,
            filteredClientes: []
        }
        this.currentUser()
        this.statusVenda()
        this.getClientes()
        this.cartelasLoja()
        this.selecionar = this.selecionar.bind(this)
        this.selecionaCliente = this.selecionaCliente.bind(this)
    }

    async currentUser() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.get('usuarios/' + this.state.user._id)
            this.setState({ user: response.data })
        } catch (err) {
            console.log(err)
        }
    }


    addCarrinho(index) {
        this.state.carrinho.push(this.state.cartelas[index])
        this.forceUpdate()
    }

    removeCarrinho(index) {
        this.state.carrinho.splice(index, 1)
        this.forceUpdate()
    }

    fazerPedido = async (e) => {
        if (this.state.clienteSelecionado == '' || this.state.clienteSelecionado == null || this.state.carrinho.length == 0) {
            alert('Selecione o cliente / selecione suas cartelas')
            return ''
        }
        this.removeDuplicada()
        this.setState({ clicked: true })

    }

    ordenaCartelas(a, b) {
        if (a.codigo > b.codigo) {
            return 1;
        }
        if (a.codigo < b.codigo) {
            return -1;
        }

        return 0;

    }

    removeDuplicada() {
        var car = [...this.state.carrinho.sort(this.ordenaCartelas)];
        var carrinho = this.state.carrinho.sort(this.ordenaCartelas);
        carrinho.map((cartela, index) => {
            var lastItem = car[index - 1];
            var nextItem = car[index + 1];
            if (car[index] != undefined && lastItem != undefined) {
                if (car[index].codigo == lastItem.codigo) {
                    car.splice(index, 1);
                }
            }
            if (car[index] != undefined && nextItem != undefined) {
                {
                    if (car[index].codigo == nextItem.codigo) {
                        car.splice(index, 1);
                    }
                }
            }
        })
        this.setState({ carrinho: car.sort(this.ordenaCartelas) })
        this.efetuarPedido()
    }

    async efetuarPedido(e) {
        this.state.carrinho.map((item, index) => {
            this.state.lote.cartelas.splice(this.state.lote.cartelas.indexOf(item), 1)
        })

        const loteId = this.state.lote._id
        this.setState({ buy: true })


        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('lotes/atualizar-lote', {
                _id: this.state.lote._id,
                cartelas: this.state.lote.cartelas
            })
        } catch (err) {
            console.log(err)
        }
        try {

            const responseTransacao = await axiosInstance.post('transacoes/criar-transacao', {
                data: new Date(),
                documento: 'LOJA CAMBISTA',
                valor: this.state.carrinho.length * this.state.carrinho[0].valor,
                emissorId: this.state.clienteSelecionado,
                receptorId: this.state.user._id,
                tipo: 'Venda',
                observacao: 'Venda recebida',
                status: true,
                natureza: 'ENTRADA',
                taxaComissao: this.state.carrinho.length * this.state.user.comissao
            })
            const response2 = await axiosInstance.post(
                'pedidos/fazer-pedido-cambista',
                {
                    cartelas: this.state.carrinho,
                    loteId: loteId,
                    dataCriacao: new Date(),
                    comissao: this.state.user.comissao,
                    clienteId: this.state.clienteSelecionado,
                    cambistaId: this.state.user._id,
                    gerenteId: this.state.user.tutorId._id,
                    recebido: true,
                    codigo: '',
                    transacaoId: responseTransacao.data._id
                }
            )
            if (response2)
                this.props.history.push('/receber-pedidos')
        } catch (err) {
            console.log(err)
        }
    }

    getUser = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('usuarios/user', {
                id: this.state.user._id
            })

            window.localStorage.setItem('user', JSON.stringify(response.data[0]))
        } catch (err) {
            console.log(err)
        }
    }

    getClientes = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('usuarios/listar-por-tutor', {
                tutorId: this.state.user._id
            })
            this.setState({ clientes: response.data.sort(this.compararNome) })
        } catch (err) {
            console.log(err)
        }
    }


    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }

    cartelasLoja = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('lotes/cartelas-loja', {})
            // this.setState({ lotes: response.data });
            // this.setState({ lote: this.state.lotes[Math.floor(Math.random() * this.state.lotes.length)] });
            this.setState({ lote: response.data })

            if (!this.state.lote) {
                window.location.reload()
            }

            var index =
                Math.floor(Math.random() * (this.state.lote.cartelas.length - 10)) +
                1
            this.setState({
                cartelas: this.state.lote.cartelas.slice(index, index + 10)
            })
        } catch (err) {
            console.log(err)
        }
    }

    selecionaCliente(event) {

        if (event.target.accessKey) {
            document.getElementById('cliente-input').value = JSON.parse(event.target.accessKey).nome;
            this.setState({
                clienteSelecionado: JSON.parse(event.target.accessKey),
                filteredClientes: []
            })
        }

        this.forceUpdate()
    }

    selecionar(event) {
        //REMOVE
        if (
            event.target.name > -1 &&
            document
                .getElementById('item-' + event.target.name)
                .classList.contains('selecionado')
        ) {
            document
                .getElementById('item-' + event.target.name)
                .classList.remove('selecionado')
            document
                .getElementById('sel-tit-' + event.target.name)
                .classList.add('collapse')
            this.removeCarrinho(event.target.name);
        }
        //ADD
        else if (
            event.target.name > -1 &&
            !document
                .getElementById('item-' + event.target.name)
                .classList.contains('selecionado')
        ) {
            document
                .getElementById('item-' + event.target.name)
                .classList.add('selecionado')
            document
                .getElementById('sel-tit-' + event.target.name)
                .classList.remove('collapse')
            this.addCarrinho(event.target.name)
        }
    }

    async statusVenda() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.get('parametros/venda-status', {})
            this.setState({ statusVenda: response.data })
        } catch (err) {
            console.log(err)
        }
    }


    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    async filtrarClientes(e) {
        if (e.target.value != '') {
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem('apiUrl')
                })
                const response = await await axiosInstance.post('usuarios/filtrar-clientes-por-tutor', {
                    spell: e.target.value,
                    tutorId: this.state.user._id
                })
                this.setState({ filteredClientes: response.data })
            } catch (err) {
                console.log(err)
            }
        }
        else {
            this.setState({ filteredClientes: [] })
        }
    }

    render() {
        const screenWidth = this.state.screenWidth >= 960 ? 3 : 1
        var settings = {
            dots: true,
            infinite: false,
            speed: 1,
            slidesToShow: screenWidth,
            slidesToScroll: 1
        }
        return (

            <CambistaTemplate label="Loja">
                {(!this.state.statusVenda && this.state.user.status && this.state.user.tutorId.status && !this.state.user.tutorId.bloqVendas) ?
                    <div class="">
                        {this.state.buy ? <CircularDeterminate cambista={true} max={100} /> : ''}
                        <div class="container-fluid">
                            <div class="input-group mb-3">
                                {/* <select
                                    onChange={this.selecionaCliente}
                                    class="custom-select w-100"
                                    id="inputGroupSelect02"
                                >
                                    <option selected value={null}>Nenhum...</option>
                                    {this.state.clientes != null
                                        ? this.state.clientes.map((item, index) => {
                                            return <option value={index}>{item.nome} - {item.telefone}</option>
                                        })
                                        : ''}
                                </select> */}
                                <input id="cliente-input" className="form-control" placeholder="Filtrar a lista de clientes por nome" onChange={this.filtrarClientes.bind(this)}></input>
                                {this.state.filteredClientes.length > 0 ?
                                    <div className="clientes-popup">
                                        {this.state.filteredClientes.map(cliente => {
                                            return <div onClick={this.selecionaCliente.bind(this)} accessKey={JSON.stringify(cliente)}><span accessKey={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</span></div>
                                        })}

                                    </div>
                                    : ''}
                            </div>

                            <Slider class="p-5 w-100" {...settings}>
                                {this.state.cartelas != null
                                    ? this.state.cartelas.map((item, index) => {
                                        return (
                                            <button
                                                class={"superContainer p-2"}
                                                onClick={this.selecionar}
                                                name={index}
                                            >
                                                <div
                                                    id={'item-' + index}
                                                    class="card text-white bg-dark mb-3 shadow"
                                                >
                                                    <div class="bg-dark card-header ">
                                                        <div class="container ">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <div class="row">
                                                                        <span class="font-weight-bold">
                                                                            código : <Link class="text-danger">{item.codigo}</Link>
                                                                        </span>
                                                                    </div>
                                                                    <div class="row">
                                                                        <span class="font-weight-bold text-warning">
                                                                            Data do sorteio : <Link class="text-light">{this.formatDate(item.data)}</Link>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col">
                                                                    <div class="row justify-content-end">
                                                                        <span class="font-weight-bold">
                                                                            lote: <Link class="text-danger">{this.state.lote.codigo}</Link>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="bg-dark card-body justify-content-center ajustar">
                                                        <div
                                                            class="bg-light rounded"
                                                            style={{ width: '17.8em', height: '10em' }}
                                                        >
                                                            <div class="container text-dark tracado ">
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <span>{item.numeros[0]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[1]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[2]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[3]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[4]}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <span>{item.numeros[5]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[6]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[7]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[8]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[9]}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <span>{item.numeros[10]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[11]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[12]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[13]}</span>
                                                                    </div>
                                                                    <div class="col">
                                                                        <span>{item.numeros[14]}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span
                                                    id={'sel-tit-' + index}
                                                    class="collapse font-weight-bold text-success"
                                                >
                                                    Selecionado
                                                </span>
                                            </button>
                                        )
                                    })
                                    : ''}
                            </Slider>
                            <div class="mt-5 container">
                                <div class="row borda">
                                    <div class="col justify-content-center text-center">
                                        <span class="font-weight-bold text-dark">
                                            Quantidade:
                                        </span>{' '}
                                        <span>{this.state.carrinho.length}</span>
                                    </div>
                                    <div class="col justify-content-center">
                                        <div class="row justify-content-center">
                                            <span class="font-weight-bold text-dark">Valor:</span>{" "}
                                        </div>
                                        <div class="row justify-content-center">
                                            <span>R$: {this.state.lote ? this.state.lote.cartelas.length > 0 ? this.state.lote.cartelas[0].valor : '0.00' : '0.00'}</span>
                                        </div>
                                    </div>
                                    <div class="col justify-content-center">
                                        <div class="row justify-content-center">
                                            <span class="font-weight-bold text-dark">Total: </span>{" "}
                                        </div>
                                        <div class="row justify-content-center">
                                            <span> R$ : {this.state.lote ? this.state.lote.cartelas.length > 0 ? (this.state.carrinho.length * (this.state.lote ? this.state.lote.cartelas[0].valor : 0)).toFixed(2) : '0.00' : '0.00'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col justify-content-center text-center">
                                        <button
                                            disabled={this.state.clicked}
                                            onClick={this.fazerPedido}
                                            class="w-50 btn btn-success bg-success text-light"
                                        >
                                            COMPRAR
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <div class="content">
                        <div class="text-center bg-dark text-warning p-3 rounded"><h3>Desculpe, no momento não estamos
                            vendendo!</h3></div>
                    </div>}

            </CambistaTemplate>
        )
    }
}

export default LojaCambista
